import { useEffect, useState } from "react";
import { waLink } from "../../lib/wa";

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { href: "#layanan", label: "Layanan" },
        { href: "#portofolio", label: "Portofolio" },
        { href: "#harga", label: "Harga" },
        { href: "#faq", label: "FAQ" },
    ];

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-jws-bg/80 border-b border-jws-border"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between h-[68px] md:h-[72px]">
                <a
                    href="#top"
                    data-testid="logo-home"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src="/brand/logo.png"
                        alt="Jayapura Web Studio"
                        className="h-11 w-11 object-contain group-hover:rotate-[-8deg] transition-transform duration-500 drop-shadow-[0_2px_6px_rgba(28,58,42,0.25)]"
                    />
                    <span className="font-display text-xl tracking-tight">
                        Jayapura
                        <span className="text-jws-primary">.</span>
                        <span className="ml-1 italic font-light">studio</span>
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-8 text-sm">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="link-underline text-jws-text/80 hover:text-jws-text"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-wa-cta"
                        className="hidden md:inline-flex items-center gap-2 rounded-full bg-jws-text text-jws-bg px-5 py-2.5 text-sm font-medium hover:bg-jws-primary transition-colors"
                    >
                        <span className="h-1.5 w-1.5 rounded-full bg-jws-ochre animate-pulse" />
                        Chat WhatsApp
                    </a>
                    <button
                        onClick={() => setOpen(!open)}
                        data-testid="nav-mobile-toggle"
                        className="md:hidden p-2 -mr-2"
                        aria-label="Toggle menu"
                    >
                        <div className="space-y-1.5">
                            <span
                                className={`block h-px w-6 bg-jws-text transition-all ${open ? "translate-y-2 rotate-45" : ""}`}
                            />
                            <span
                                className={`block h-px w-6 bg-jws-text transition-all ${open ? "opacity-0" : ""}`}
                            />
                            <span
                                className={`block h-px w-6 bg-jws-text transition-all ${open ? "-translate-y-2 -rotate-45" : ""}`}
                            />
                        </div>
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden bg-jws-bg border-t border-jws-border"
                >
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="font-display text-2xl"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={waLink()}
                            target="_blank"
                            rel="noreferrer"
                            className="mt-2 inline-flex items-center justify-center rounded-full bg-jws-primary text-white px-5 py-3 font-medium"
                        >
                            Chat WhatsApp
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
